import React, { useEffect, useState, useRef } from "react";
import Header from "../layout/Header";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import Swal from "sweetalert2";
import { getAddresses } from "../../actions/payment/getAddresses";
import PhoneInput from "react-phone-input-2";
import { getCitiesByDistrictName } from "../../actions/payment/getCitiesByDistrictName";
import { addAddress, resetAddAddress } from "../../actions/payment/addAddress";
import { checkout, resetCheckout } from "../../actions/payment/checkout";
import { getBasket } from "../../actions/payment/getBasket";
import { addBasket, resetAddBasket } from "../../actions/payment/addBasket";
import { formatCardNumber } from "../../helpers/formatter";
import { Link } from "react-router-dom";
import { getMSS } from "../../actions/agreement/getMSS";
import { signMSS } from "../../actions/agreement/signMSS";
import {
  removeAddress,
  resetRemoveAddress
} from "../../actions/payment/removeAddress";
import { getApplication } from "../../actions/application/getApplication";
import { getDistrict } from "../../actions/payment/getDistrict";
import SearchableDropdown from "../../components/helperscomponents/SearchableDropdown";
import { cartUpdate } from "../../actions/payment/cartUpdate";
import { DatePicker, Modal } from "antd"; // Ant Design Modal bileşenini ekledim
import { useFacility } from "../../context/FacilityContext";

function PaymentV2(props) {
  function validateCardNumber(number) {
    return number.length === 16; // Basit bir örnek
  }

  function validateExpiryDate(date) {
    return /(?:0[1-9]|1[0-2])\/[0-9]{2}/.test(date); // "MM/YY" formatı
  }

  function validateCVV(cvv) {
    // CVV'nin doğru formatta olduğunu kontrol et
    return cvv.length === 3; // Basit bir örnek
  }

  const { Id } = useParams();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [district, setDistrict] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine4, setAddressLine4] = useState("");
  const [postCode, setPostCode] = useState("");
  const [locality, setLocality] = useState("");
  const [mail, setEmail] = useState("");
  const [nameSurname, setNameSurname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvv, setCvv] = useState("");
  const location = useLocation();
  const [approve, setApprove] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get("status");
  const [mss, setMss] = useState("");
  const [customName, setCustomName] = useState("");
  const [modalType, setModalType] = useState("add");
  const [discountCodes, setDiscountCodes] = useState([""]);
  const [isCodeApplied, setIsCodeApplied] = useState(false); // İndirim kodunun başarıyla uygulanıp uygulanmadığını takip eder
  const [errors, setErrors] = useState({});
  const cartUpdateState = useSelector((state) => state.cartUpdate);
  const { facility } = useFacility(); // Context API'den facility al

  const [grandTotal, setGrandTotal] = useState(
    cartUpdateState?.cartUpdate?.basket?.grandTotal || 0
  );

  useEffect(() => {
    if (!facility) {
      navigate("/select-facility"); // Facility bilgisi yoksa yönlendir
    }
  }, [facility, navigate]);

  // Modal görünürlük durumları
  const [isMSSModalVisible, setIsMSSModalVisible] = useState(false);
  const [isAddressModalVisible, setIsAddressModalVisible] = useState(false);
  const isUpdateInProgress = useRef(false);
  const isBasketFetchInProgress = useRef(false);

  useEffect(() => {
    // Sayfa değiştiğinde resetAddBasket çağrılır
    dispatch(resetAddBasket());
  }, [location.pathname, dispatch]);

  useEffect(() => {
    if (props.addAddress.done) {
      setIsAddressModalVisible(false);
      setErrors({}); // Hataları sıfırla
    }
  }, [props.addAddress]);

  useEffect(() => {
    const resetAndAddBasket = async () => {
      if (isUpdateInProgress.current) return; // Güncelleme devam ediyorsa işlemi atla
      isUpdateInProgress.current = true;

      try {
        // Sepeti sıfırla
        await dispatch(cartUpdate("reset", 0));

        // Yeni ürünü sepete ekle
        const jsonData = JSON.stringify({ applicationId: Id });

        // Redux üzerinden gelen facility bilgisine göre handle belirle
        const handle =
          facility === "başkent" ? "second-opinion" : "second-opinion-level2";

        await dispatch(addBasket(null, 0, 1, jsonData, handle, true, true));
      } catch (error) {
        console.error("Sepeti güncellerken hata oluştu:", error);
      } finally {
        isUpdateInProgress.current = false;
      }
    };

    resetAndAddBasket();
  }, [dispatch, facility, Id]); // facility artık Redux'tan alındığı için facilitys.facility kullanılmıyor

  useEffect(() => {
    const updateBasketAndCheckout = async () => {
      if (isUpdateInProgress.current) return; // Güncelleme zaten devam ediyorsa işlemi atla
      isUpdateInProgress.current = true; // İşleme başladık

      try {
        // Adres kontrolü
        const addressId =
          props.getAddresses.getAddresses?.data?.addresses?.[0]?.addressId;

        if (!addressId) {
          console.error("Adres bilgisi bulunamadı!");
          return;
        }

        // Checkout işlemini başlat
        await dispatch(cartUpdate("checkout", 0, addressId));
      } catch (error) {
        console.error("Sepeti güncellerken bir hata oluştu:", error);
      } finally {
        isUpdateInProgress.current = false; // İşlem tamamlandı
      }
    };

    if (props.getAddresses.done) {
      updateBasketAndCheckout();
    }
  }, [props.getAddresses, dispatch]);

  useEffect(() => {
    if (
      props.addBasket.done &&
      !props.getBasket.inProgress &&
      !isBasketFetchInProgress.current
    ) {
      isBasketFetchInProgress.current = true; // Sepet bilgisi alınıyor
      dispatch(getBasket());
    }
  }, [props.addBasket.done, props.getBasket.inProgress, dispatch]);

  useEffect(() => {
    if (status == "failed") {
      Swal.fire({
        icon: "error",
        title: "Ödeme işlemi başarısız",
        text: "Ödeme işlemi başarısız. Lütfen tekrar deneyiniz.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
      });
      return;
    }
    if (status == "success") {
      dispatch(resetCheckout());
      navigate("/applications");
      return;
    }
  }, [status]);

  useEffect(() => {
    if (props.getMSS.done) {
      setMss(props.getMSS.getMSS.data.article.content);
    }
  }, [props.getMSS]);

  if (props.getApplication.done) {
    var surveyData = JSON.parse(
      props.getApplication?.getApplication?.survey?.data
    );
    var userNameSurname =
      props.getApplication?.getApplication?.applicationOwnerUser?.name +
      " " +
      props.getApplication?.getApplication?.applicationOwnerUser?.lastName;
    var professionName = surveyData["Görüş Almak İstediğiniz Uzmanlık Alanı"];
    var doctorNameSurname =
      props.getApplication?.getApplication?.assignments[0]?.doctor?.name +
      " " +
      props.getApplication?.getApplication?.assignments[0]?.doctor?.lastName;
  }

  useEffect(() => {
    dispatch(getApplication(Id));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAddresses());
  }, [dispatch]);

  useEffect(() => {
    if (cartUpdateState?.done) {
      setGrandTotal(cartUpdateState.cartUpdate.basket.grandTotal); // Eğer setState kullanıyorsanız
    }
  }, [cartUpdateState]);

  // useEffect(() => {
  //   if (
  //     props.getCitiesByDistrictName.done &&
  //     props.getCitiesByDistrictName.getCitiesByDistrictName.data.matches
  //       .length > 0
  //   ) {
  //     setLocality(
  //       props.getCitiesByDistrictName.getCitiesByDistrictName.data.matches[0].r
  //         .v
  //     );
  //   }
  // }, [props.getCitiesByDistrictName]);

  useEffect(() => {
    if (props.addAddress.done) {
      Swal.fire({
        icon: "success",
        title: "İşlem başarılı",
        text: "Adres ekleme işlemi başarılı.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
      });
      dispatch(resetAddAddress());
      dispatch(getAddresses());
      return;
    }
  }, [props.addAddress]);

  function HandleSearchDistrict(districtName) {
    dispatch(getCitiesByDistrictName(districtName));
  }

  const validateFields = () => {
    const newErrors = {};
    if (!customName.trim()) newErrors.customName = "Başlık zorunludur.";
    if (!nameSurname.trim()) newErrors.nameSurname = "İsim Soyisim zorunludur.";
    if (!postCode.trim()) newErrors.postCode = "Posta kodu zorunludur.";
    if (!locality.trim()) newErrors.locality = "İl zorunludur.";
    if (!district.trim()) newErrors.district = "İlçe zorunludur.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const HandleSetAddress = () => {
    if (validateFields()) {
      let address = {
        isValid: true,
        isCompany: false,
        email: mail,
        contactName: nameSurname,
        phone1: phoneNumber,
        ssn: "",
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        addressLine4: addressLine4,
        phone1Code: "+90",
        postCode: postCode,
        locality: locality,
        district: district
      };
  
      dispatch(addAddress(address, true, 2, customName));
  
      // Hataları sıfırla ve modalı kapat
      setErrors({});
      setIsAddressModalVisible(false);
    }
  };
  

  var paymentInfo = {
    cardNumber: cardNumber,
    cardHolderName: nameSurname,
    exprMonth: expiryDate.slice(0, 2),
    exprYear: 20 + expiryDate.slice(-2),
    cv2: cvv
  };

  const baseDomain = window.location.origin;

  var successAction = {
    actionType: 1,
    parameters: {
      url: `${baseDomain}/applications?status=success`
    }
  };
  var failAction = {
    actionType: 1,
    parameters: {
      url: `${baseDomain}/paymentv2/${Id}?status=failed&facility=${facility}`
    }
  };

  function HandlePayment() {
    if (grandTotal !== 0) {
      // Eğer grandTotal sıfır değilse validasyonları kontrol et
      if (props.getAddresses?.getAddresses?.data?.addresses?.length === 0) {
        Swal.fire({
          title: "Eksik adres bilgisi.",
          text: "Lütfen geçerli bir adres bilgisi ekleyiniz!",
          icon: "warning",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Anladım"
        });
        setIsAddressModalVisible(true); // Ant Design Modal'ı açmak için state'i güncelledim
        return;
      }

      if (!approve) {
        Swal.fire({
          icon: "error",
          title: "Lütfen sözleşmeyi okuyup onaylayınız",
          confirmButtonText: "Anladım"
        });
        return;
      }

      if (
        !validateCardNumber(cardNumber) ||
        !validateExpiryDate(expiryDate) ||
        !validateCVV(cvv)
      ) {
        Swal.fire({
          icon: "error",
          title: "Lütfen kart bilgilerini eksiksiz giriniz",
          confirmButtonText: "Anladım"
        });
        return;
      }
    }

    // GrandTotal kontrolü
    const paymentType = grandTotal === 0 ? 14 : 13;

    dispatch(checkout(paymentType, paymentInfo, successAction, failAction, Id));

    if (props.checkout.done) {
      window.location.reload();
    }
  }

  const [iframeContent, setIframeContent] = useState("");
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (props.checkout.done) {
      if (grandTotal === 0) {
        Swal.fire({
          icon: "success",
          title: "Ödeme Tamamlandı",
          text: "Ücretsiz başvurunuz başarıyla tamamlandı.",
          confirmButtonText: "Tamam"
        }).then(() => {
          navigate("/applications");
          dispatch(resetCheckout()); // Redux state’i sıfırlıyoruz
        });
      } else if (isMobile) {
        setIframeContent(
          props.checkout.checkout?.data?.paymentResult?.resultMessage
        );
      } else {
        const paymentResultMessage =
          props.checkout.checkout?.data?.paymentResult?.resultMessage;
        if (paymentResultMessage) {
          const openNewPageWithHtmlContent = (htmlContent) => {
            const newWindow = window.open("", "_blank");
            if (newWindow) {
              setTimeout(() => {
                newWindow.document.write(htmlContent);
                newWindow.document.close();
              }, 1000);
            }
          };
          openNewPageWithHtmlContent(paymentResultMessage);
          dispatch(resetCheckout()); // Redux state’i sıfırlıyoruz
        }
      }
    }

    if (props.checkout.error) {
      const errorData = props.checkout.error.response.data;
      const errorMessage =
        errorData.message ||
        "Bilgiler eksik veya yanlış. Lütfen tekrar deneyin.";
      Swal.fire({
        icon: "error",
        title: "Bir hata oluştu",
        text: errorMessage,
        confirmButtonText: "Anladım"
      });
    }
  }, [props.checkout, isMobile, grandTotal, navigate, dispatch]);

  useEffect(() => {
    if (props.removeAddress.done) {
      Swal.fire({
        icon: "success",
        title: "İşlem başarılı",
        text: "Adres silme işlemi başarılı.",
        confirmButtonText: "Anladım",
        footer:
          '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
      });
      dispatch(getAddresses());
      dispatch(resetRemoveAddress());
    }
  }, [props.removeAddress]);

  const updateDiscountCode = (value) => {
    setDiscountCodes([value]); // Sadece bir indirim kodu olacak
  };

  const applyAllDiscountCodes = async () => {
    const code = discountCodes[0]?.trim(); // İlk ve tek kodu al
    if (!code) {
      Swal.fire({
        icon: "error",
        title: "İndirim kodu girmediniz",
        confirmButtonText: "Anladım"
      });
      return;
    }

    dispatch(
      cartUpdate(
        "checkout",
        0,
        props.getAddresses.getAddresses?.data?.addresses[0]?.addressId,
        [code]
      )
    )
      .then(async (data) => {
        if (data?.errors?.length > 0) {
          Swal.fire({
            icon: "error",
            title: "İndirim kodu geçersiz",
            text: data.errors.join(", "),
            confirmButtonText: "Anladım"
          });
        } else {
          // GrandTotal güncellenir
          Swal.fire({
            icon: "success",
            title: "İndirim kodu uygulandı",
            confirmButtonText: "Tamam"
          });
          setDiscountCodes([code]); // Kod kaydedilir
          setIsCodeApplied(true); // Disable durumunu kontrol etmek için
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Bir hata oluştu",
          text: "Lütfen tekrar deneyiniz.",
          confirmButtonText: "Tamam"
        });
      });
  };

  const handleDateChange = (date, dateString) => {
    setExpiryDate(dateString); // AA/YY formatında alır
  };

  return (
    <>
      {isMobile && iframeContent ? (
        <iframe
          srcDoc={iframeContent} // Set the HTML content directly in srcDoc
          style={{ width: "100%", height: "100vh", border: "none" }}
          title="Checkout Content"
        />
      ) : (
        <div>
          <Header />
          <div className="grid max-w-md md:max-w-full">
            <div className="pt-2 md:ml-64 ps-5">
              <ol
                className="flex items-center whitespace-nowrap min-w-0"
                aria-label="Breadcrumb"
              >
                <li className="text-xs">
                  <p className="flex items-center text-gray-500">
                    Yeni Başvuru
                    <svg
                      className="flex-shrink-0 mx-1 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </p>
                </li>
                <li className="text-xs">
                  <p className="flex items-center text-gray-500">
                    Talep Formu
                    <svg
                      className="flex-shrink-0 mx-1 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </p>
                </li>
                <li className="text-xs">
                  <p className="flex items-center text-gray-500">
                    Dosya Yükleme
                    <svg
                      className="flex-shrink-0 mx-1 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </p>
                </li>
                <li
                  className="text-xs font-semibold text-gray-800 truncate dark:text-gray-200"
                  aria-current="page"
                >
                  Ödeme
                </li>
              </ol>
            </div>
            <hr className="divide-y mt-2" />
            <h1 className="text-2xl font-semibold text-start mt-5 ps-5 md:ml-64">
              Ödemeyi Tamamla
            </h1>

            <div className="grid items-center gap-4 mt-5 ps-5 pe-5 md:ml-64">
              <div className="md:col-span-1">
                <div className="flex justify-between items-center ps-5 me-5">
                  <h2>Kayıtlı adresleriniz</h2>
                  <button
                    id="entas"
                    onClick={() => {
                      setNameSurname("");
                      setEmail("");
                      setPhoneNumber("");
                      setAddressLine1("");
                      setAddressLine2("");
                      setDistrict("");
                      setLocality("");
                      setPostCode("");
                      setModalType("add"); // Modal tipi ekleme olarak ayarlandı
                      setIsAddressModalVisible(true); // Ant Design Modal'ı açmak için state'i güncelledim
                    }}
                    type="button"
                    className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-500 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                  >
                    <p>Adres Ekle</p>
                  </button>
                </div>

                {props.getAddresses.done ? (
                  props.getAddresses.getAddresses.data.addresses.length != 0 ? (
                    props.getAddresses.getAddresses.data.addresses.map(
                      (element, index) => {
                        return (
                          <div
                            key={index}
                            className="relative bg-slate-100 border rounded-md p-3 mt-5 text-start"
                          >
                            <div className="flex flex-col space-y-3">
                              <div className="relative bg-slate-100 border rounded-md p-3 text-start">
                                <div className="absolute top-2 right-2 flex space-x-2">
                                  {/* Sil butonu */}
                                  <button
                                    onClick={(e) => {
                                      Swal.fire({
                                        title: "Emin misiniz?",
                                        text: "Kayıtlı adresiniz silinecektir!",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Sil",
                                        cancelButtonText: "Vazgeç"
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          dispatch(
                                            removeAddress(element.addressId)
                                          );
                                        }
                                      });
                                    }}
                                    className="p-1 text-white bg-[#ff3c3c] rounded-lg hover:bg-[#e62e2e] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ff3c3c]"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M6 18L18 6M6 6l12 12"
                                      ></path>
                                    </svg>
                                  </button>
                                </div>
                                <div className="flex items-center mt-1 w-full">
                                  <input
                                    id={`hs-radio-delete${index}`}
                                    name="hs-radio-with-description"
                                    type="radio"
                                    className="border-gray-200 rounded-full text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                    aria-describedby={`hs-radio-delete-description${index}`}
                                    defaultChecked
                                  />
                                  <label
                                    htmlFor={`hs-radio-delete${index}`}
                                    className="ml-3 block text-sm font-semibold text-gray-800 w-full"
                                  >
                                    <span className="block text-sm font-semibold text-gray-800 truncate">
                                      {element.customName
                                        ? element.customName
                                        : element.address.addressLine1}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )
                  ) : (
                    <div className="relative bg-slate-100 border rounded-sm mt-5 ms-10 me-10 text-start">
                      <div className="top-0 left-0 right-0">
                        <div
                          className="bg-red-50 border border-red-200 rounded-md p-4"
                          role="alert"
                        >
                          <div className="flex">
                            <div className="flex-shrink-0">
                              <svg
                                className="h-4 w-4 text-red-400 mt-0.5"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                              >
                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                              </svg>
                            </div>
                            <div className="ml-4">
                              <h3 className="text-sm text-red-800 font-semibold">
                                Fatura adresiniz bulunmamaktadır
                              </h3>
                              <div className="mt-2 text-sm text-red-700">
                                <p>
                                  Lütfen{" "}
                                  <button
                                    type="button"
                                    className=""
                                    onClick={() => {
                                      setModalType("add");
                                      setIsAddressModalVisible(true); // Ant Design Modal'ı açmak için state'i güncelledim
                                    }}
                                  >
                                    <b>fatura adresi</b> ekleyiniz.
                                  </button>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                ) : null}

                <hr className="divide-y m-2" />
                <div className=" bg-slate-100 border rounded-sm mt-2 text-start">
                  <div className="flex flex-col">
                    <div className="grid md:flex justify-start items-center space-x-4 p-4 md:p-5">
                      <div className="border border-gray-200 p-2 bg-white rounded-md shadow-xl">
                        <p className="font-semibold text-xs text-gray-900">
                          Başvuru Sahibi
                        </p>
                        <p className=" text-gray-800">{userNameSurname}</p>
                      </div>
                      {/* <div className="border border-gray-200 p-2 bg-white rounded-md shadow-xl">
                        <p className=" font-semibold text-xs text-gray-800">
                          Görüş Alınan Uzmanlık Alanı
                        </p>
                        <p className=" text-gray-800">{professionName}</p>
                      </div>
                      <div className="border border-gray-200 p-2 bg-white rounded-md shadow-xl">
                        <p className="font-semibold text-xs text-gray-800">
                          Görüş Alınan Hekim
                        </p>
                        <p className=" text-gray-800">{doctorNameSurname}</p>
                      </div> */}
                    </div>
                    <div className="flex justify-start items-center p-5 m-5 border border-gray-200 shadow-lg  bg-white rounded-md">
                      <div>
                        <p className="font-semibold text-xs text-gray-800">
                          Başvuru Ücreti
                        </p>
                        {isCodeApplied ? (
                          <p className="text-xl text-red-400 opacity-50 font-semibold line-through">
                            <>
                              {
                                props.addBasket?.addBasket?.data?.basket
                                  ?.grandTotal
                              }
                              {
                                props.addBasket?.addBasket?.data?.basket
                                  ?.currencySymbol
                              }
                            </>
                          </p>
                        ) : (
                          <p className="text-3xl text-green-600 font-semibold">
                            <>
                              {
                                props.addBasket?.addBasket?.data?.basket
                                  ?.grandTotal
                              }
                              {
                                props.addBasket?.addBasket?.data?.basket
                                  ?.currencySymbol
                              }
                            </>
                          </p>
                        )}
                        <p className="text-3xl text-green-600 font-semibold">
                          {isCodeApplied &&
                            grandTotal +
                              props.addBasket?.addBasket?.data?.basket
                                ?.currencySymbol}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="divide-y mt-2" />
                {/* İNDİRİM KODU ALANI */}
                {facility === "başkent" && (
                  <div className="bg-slate-100 border rounded-sm text-start p-4 md:col-span-1 mt-2 flex items-center justify-start space-x-4">
                    <h3 className="text-xs font-semibold">İndirim Kodu:</h3>
                    <div className="flex items-center space-x-3">
                      <input
                        type="text"
                        value={discountCodes[0]}
                        onChange={(e) => updateDiscountCode(e.target.value)}
                        placeholder="İndirim kodu girin"
                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                        disabled={isCodeApplied} // Başarılı uygulandıysa disable
                      />
                    </div>
                    <div className="flex items-center justify-center">
                      <button
                        onClick={applyAllDiscountCodes}
                        className={`py-2 px-4 rounded-md ${
                          isCodeApplied
                            ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                            : "bg-blue-500 text-white hover:bg-blue-600"
                        } focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        disabled={isCodeApplied} // Başarılı uygulandıysa disable
                      >
                        Uygula
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <hr className="divide-y" />

              <div>
                {grandTotal > 0 && (
                  <div className="bg-slate-100 border rounded-sm text-start p-4 md:col-span-1">
                    <div className="text-start">
                      <label
                        htmlFor="input-label1"
                        className="block text-sm font-medium mb-2 dark:text-white"
                      >
                        İsim Soyisim
                      </label>
                      <input
                        onChange={(e) => {
                          setNameSurname(e.target.value);
                        }}
                        type="text"
                        id="input-label1"
                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                        placeholder="Banka/Kredi Kartı Üzerinde Bulunan İsim ve Soyisim"
                      />
                    </div>
                    <div
                      style={{ padding: 0 }}
                      className="grid grid-cols-4 gap-4 text-start mt-5"
                    >
                      <div className="col-span-2">
                        <label
                          htmlFor="hs-trailing-icon"
                          className="block text-sm font-medium mb-2 dark:text-white"
                        >
                          Banka/Kredi Kartı Üzerinde 16 Haneli Numara
                        </label>
                        <div className="relative">
                          <input
                            onChange={(e) => {
                              const formattedValue = formatCardNumber(
                                e.target.value
                              );
                              // Ekranda formatlanmış değeri göster
                              e.target.value = formattedValue;
                              // State'e formatlanmamış değeri kaydet
                              setCardNumber(formattedValue.replace(/-/g, ""));
                            }}
                            type="text"
                            id="hs-trailing-icon"
                            name="hs-trailing-icon"
                            className="py-3 px-4 pr-11 block w-full border-gray-200 shadow-sm rounded-md text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                            placeholder="xxxx-xxxx-xxxx-xxxx"
                          />
                          <div className="absolute inset-y-0 right-0 flex items-center pointer-events-none z-20 pr-4">
                            <svg
                              className="h-4 w-4 text-gray-400"
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1z" />
                              <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2zm13 2v5H1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-1 9H2a1 1 0 0 1-1-1v-1h14v1a1 1 0 0 1-1 1z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label
                          htmlFor="dateInput"
                          className="block text-sm font-medium mb-2 dark:text-white"
                        >
                          Son Kullanma Tarihi
                        </label>
                        <DatePicker
                          onChange={handleDateChange}
                          picker="month" // Ay ve yıl seçimi
                          format="MM/YY" // AA/YY formatı
                          className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                          placeholder="AA/YY"
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="input-label3"
                          className="block text-sm font-medium mb-2 dark:text-white"
                        >
                          CVV Numarası
                        </label>
                        <input
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,3}$/.test(value)) {
                              setCvv(value);
                            }
                          }}
                          value={cvv} // cvv state'ini bağlayın
                          type="text"
                          id="input-label3"
                          className="py-3 px-4 mb-5 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                          placeholder="CVV"
                          maxLength={3} // Maksimum 3 karakter
                          inputMode="numeric" // Mobil cihazlar için sayısal klavye
                          pattern="\d*" // Sadece sayılar
                        />
                      </div>
                    </div>

                    {/* Ant Design MSS Modal */}
                    <Modal
                      title="Mesafeli Satış Sözleşmesi"
                      open={isMSSModalVisible}
                      onCancel={() => setIsMSSModalVisible(false)}
                      footer={[
                        <div className="flex justify-end space-x-2">
                          <button
                            key="back"
                            onClick={() => setIsMSSModalVisible(false)}
                            className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                          >
                            Vazgeç
                          </button>
                          ,
                          <button
                            key="submit"
                            onClick={() => {
                              dispatch(
                                signMSS(null, "mesafeli-satis-sozlesmesi", true)
                              );
                              setApprove(true);
                              setIsMSSModalVisible(false);
                            }}
                            style={{ backgroundColor: "#09C35C" }}
                            className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                          >
                            Okudum Anladım
                          </button>
                        </div>
                      ]}
                    >
                      <div className="p-4 overflow-y-auto max-h-[500px]">
                        {props.getMSS.done ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: props.getMSS.getMSS.data.article.content
                            }}
                          />
                        ) : null}
                      </div>
                    </Modal>
                    {/* Ant Design MSS Modal Bitişi */}
                  </div>
                )}
                {props.checkout.spinner ? (
                  <button
                    type="button"
                    style={{ backgroundColor: "#09C35C" }}
                    className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
                  >
                    <span
                      className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full"
                      role="status"
                      aria-label="loading"
                    ></span>
                    Tamamlanıyor...
                  </button>
                ) : (
                  <div>
                    <div className="flex mt-2">
                      <input
                        checked={approve}
                        data-hs-overlay="#m234"
                        onClick={() => {
                          dispatch(getMSS());
                          dispatch(
                            signMSS(null, "mesafeli-satis-sozlesmesi", true)
                          );
                          setApprove(!approve);
                        }}
                        type="checkbox"
                        className="onedose-color shrink-0 mt-0.5 border-gray-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                        id="hs-default-checkbox1"
                      />
                      <label
                        htmlFor="hs-default-checkbox1"
                        className="text-sm text-gray-500 ml-3 dark:text-gray-400"
                      >
                        <a
                          onClick={() => {
                            dispatch(getMSS());
                            setIsMSSModalVisible(true); // Ant Design Modal'ı açmak için state'i güncelledim
                          }}
                          href="#"
                          data-hs-overlay="#m234"
                          className="onedose-color"
                        >
                          Mesafeli satış sözleşmesi metnini
                        </a>{" "}
                        okudum, onayladım.
                      </label>
                    </div>
                    <button
                      onClick={HandlePayment}
                      style={{ backgroundColor: "#09C35C" }}
                      type="button"
                      className="mb-10 w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
                    >
                      Ödemeyi Tamamla
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Ant Design Address Modal */}
          <Modal
            title={modalType === "edit" ? "Adres Düzenle" : "Adres Ekle"}
            open={isAddressModalVisible}
            width={800}
            closable={false}
            onCancel={() => {
              // Hatalar varsa modal'ı kapatmayı engelle
              if (Object.keys(errors).length === 0) {
                setIsAddressModalVisible(false);
              }
            }}
            footer={[
              <div className="flex justify-end space-x-2" key="footer-buttons">
                <button
                  key="back"
                  onClick={() => setIsAddressModalVisible(false)}
                  className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                >
                  Vazgeç
                </button>
                <button
                  key="submit"
                  onClick={() => {
                    HandleSetAddress();
                  }}
                  style={{ backgroundColor: "#09C35C" }}
                  className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                >
                  Adresi kaydet
                </button>
              </div>
            ]}
          >
            <div className="text-start">
              <label
                htmlFor="input-label1"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                Başlık
              </label>
              <input
                onChange={(e) => {
                  setCustomName(e.target.value);
                }}
                value={customName}
                type="text"
                id="input-label1"
                className={`py-3 px-4 mb-1 block w-full border-gray-200 rounded-md text-sm ${
                  errors.customName
                    ? "border-red-500 focus:ring-red-500"
                    : "focus:border-blue-500 focus:ring-blue-500"
                } dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400`}
                placeholder="Lütfen adresinizin başlığını giriniz"
              />
              {errors.customName && (
                <p className="text-red-500 text-xs mt-1">{errors.customName}</p>
              )}
            </div>

            <div className="text-start">
              <label
                htmlFor="input-label1"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                İsim Soyisim
              </label>
              <input
                onChange={(e) => {
                  setNameSurname(e.target.value);
                }}
                value={nameSurname}
                type="text"
                id="input-label1"
                className={`py-3 px-4 block w-full border-gray-200 rounded-md text-sm ${
                  errors.nameSurname
                    ? "border-red-500 focus:ring-red-500"
                    : "focus:border-blue-500 focus:ring-blue-500"
                } dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400`}
                placeholder="Lütfen isim soyisim bilgilerinizi giriniz"
              />
              {errors.nameSurname && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.nameSurname}
                </p>
              )}
            </div>

            <div className="text-start mt-2">
              <label
                htmlFor="input-label1"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                Telefon Numaranız
              </label>
              <PhoneInput
                containerStyle={{ width: "100%" }}
                id="phoneNumber"
                className="py-1 block w-full border-gray-200 rounded-md text-sm border focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                type="text"
                placeholder="Telefon numaranız"
                name="phoneNumber"
                country={"tr"}
                inputStyle={{
                  width: "100%", // "100% important!" yerine doğru şekilde ayarlandı
                  border: "0px",
                  paddingLeft: "58px"
                }}
                enableSearch={false}
                required={true}
                value={phoneNumber}
                onChange={(e) => {
                  setPhoneNumber(e);
                }}
              />
            </div>
            <div className="text-start mt-2">
              <label
                htmlFor="sess"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                İl
              </label>
              <SearchableDropdown
                placeholder="Şehir seç..."
                onSelectionChange={(selectedCity) => {
                  setLocality(selectedCity.v);
                }}
                fetchDataFunction={getCitiesByDistrictName}
                data={
                  props.getCitiesByDistrictName?.getCitiesByDistrictName?.data
                    ?.matches || []
                }
                className={
                  errors.locality ? "border-red-500 focus:ring-red-500" : ""
                }
              />
              {errors.locality && (
                <p className="text-red-500 text-xs mt-1">{errors.locality}</p>
              )}
            </div>

            <div className="text-start mt-2">
              <label
                htmlFor="input-label1"
                className="block text-sm font-medium mb-2 dark:text-white"
              >
                İlçe
              </label>
              <SearchableDropdown
                placeholder="İlçe seç..."
                onSelectionChange={(e) => {
                  setDistrict(e.v);
                }}
                fetchDataFunction={getDistrict}
                data={props.getDistrict?.getDistrict?.data?.matches || []}
                className={
                  errors.district ? "border-red-500 focus:ring-red-500" : ""
                }
              />
              {errors.district && (
                <p className="text-red-500 text-xs mt-1">{errors.district}</p>
              )}
              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  Adres Detay
                </label>
                <input
                  onChange={(e) => {
                    setAddressLine1(e.target.value);
                  }}
                  type="text"
                  value={addressLine1}
                  id="input-label1"
                  className="mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen adres bilgisini giriniz"
                />
                <input
                  onChange={(e) => {
                    setAddressLine2(e.target.value);
                  }}
                  value={addressLine2}
                  type="text"
                  id="input-label1"
                  className="mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen adres bilgisini giriniz"
                />
                <input
                  onChange={(e) => {
                    setAddressLine4(e.target.value);
                  }}
                  value={addressLine4}
                  type="text"
                  id="input-label1"
                  className="mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen adres bilgisini giriniz"
                />
              </div>
              <div className="text-start mt-2">
                <label
                  htmlFor="input-label1"
                  className="block text-sm font-medium mb-2 dark:text-white"
                >
                  Posta kodu
                </label>
                <input
                  onChange={(e) => {
                    setPostCode(e.target.value);
                  }}
                  value={postCode}
                  type="text"
                  id="input-label1"
                  className={`py-3 px-4 block w-full border-gray-200 rounded-md text-sm ${
                    errors.postCode
                      ? "border-red-500 focus:ring-red-500"
                      : "focus:border-blue-500 focus:ring-blue-500"
                  } dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400`}
                  placeholder="Lütfen posta kodunu giriniz"
                />
                {errors.postCode && (
                  <p className="text-red-500 text-xs mt-1">{errors.postCode}</p>
                )}
              </div>
            </div>
          </Modal>

          {/* Ant Design Address Modal Bitişi */}
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentV2);
